var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconArrowCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.70002 7.00033L5.37715 9.27532L6.19382 10.1066L9.34794 7.00033L6.19382 3.89408L5.37715 4.72533L7.70002 7.00033ZM7.00008 12.8337C6.19314 12.8337 5.4348 12.6805 4.72508 12.3743C4.01536 12.068 3.398 11.6524 2.873 11.1274C2.348 10.6024 1.93237 9.98505 1.62612 9.27532C1.31987 8.5656 1.16675 7.80727 1.16675 7.00033C1.16675 6.19338 1.31987 5.43505 1.62612 4.72533C1.93237 4.0156 2.348 3.39824 2.873 2.87324C3.398 2.34824 4.01536 1.93262 4.72508 1.62637C5.4348 1.32012 6.19314 1.16699 7.00008 1.16699C7.80703 1.16699 8.56536 1.32012 9.27508 1.62637C9.9848 1.93262 10.6022 2.34824 11.1272 2.87324C11.6522 3.39824 12.0678 4.0156 12.374 4.72533C12.6803 5.43505 12.8334 6.19338 12.8334 7.00033C12.8334 7.80727 12.6803 8.5656 12.374 9.27532C12.0678 9.98505 11.6522 10.6024 11.1272 11.1274C10.6022 11.6524 9.9848 12.068 9.27508 12.3743C8.56536 12.6805 7.80703 12.8337 7.00008 12.8337ZM7.00008 11.667C8.30286 11.667 9.40633 11.2149 10.3105 10.3107C11.2147 9.40658 11.6667 8.3031 11.6667 7.00033C11.6667 5.69755 11.2147 4.59408 10.3105 3.68991C9.40633 2.78574 8.30286 2.33366 7.00008 2.33366C5.6973 2.33366 4.59383 2.78574 3.68966 3.68991C2.7855 4.59408 2.33341 5.69755 2.33341 7.00033C2.33341 8.3031 2.7855 9.40658 3.68966 10.3107C4.59383 11.2149 5.6973 11.667 7.00008 11.667Z",
    fill: "#26282E"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowCircle);
export default __webpack_public_path__ + "static/media/icon_arrow_circle.f47c052ce5d80b07ef1f454d1e2daf4c.svg";
export { ForwardRef as ReactComponent };